import {
  MapContainer,
  TileLayer,
  Polyline,
  Tooltip as MapTooltip,
  CircleMarker,
} from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import { useTheme } from '@mui/material';
import MapResizer from './MapResizer';

const NetworkMap = ({
  center,
  routes,
  usedAirports,
  selectedRoute,
  onSelectRoute,
  acTypeColorMap,
  maxFreq,
  getCoords,
  splitSize,
}) => {
  const theme = useTheme();

  return (
    <MapContainer center={center} zoom={5} zoomControl style={{ height: '100%', width: '100%' }}>
      <MapResizer trigger={splitSize} />
      <TileLayer
        url={theme.palette.mode === 'dark'
          ? 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png'
          : 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png'}
      />

      {routes.map((r) => {
        const c1 = getCoords(r.dep);
        const c2 = getCoords(r.arr);
        if (!c1 || !c2) return null;
        const isSelected  = selectedRoute === r.key;
        const weight      = Math.max(1, (r.totalFreq / maxFreq) * 2);
        const acTypesArr  = [...r.acTypes];
        const color       = acTypeColorMap[acTypesArr[0]] || '#607d8b';
        return (
          <Polyline
            key={r.key}
            positions={[c1, c2]}
            pathOptions={{
              color:     isSelected ? '#ff6f00' : color,
              weight:    isSelected ? weight + 2 : weight,
              opacity:   isSelected ? 1 : 0.8,
              dashArray: r.sectorType === 'INT' ? '6 4' : undefined,
            }}
            eventHandlers={{ click: () => onSelectRoute(r.key === selectedRoute ? null : r.key) }}
          >
            <MapTooltip sticky>
              <strong>{r.dep} → {r.arr}</strong><br />
              {r.sectorType} · {r.totalFreq}x/wk<br />
              AC: {acTypesArr.join(', ')}
            </MapTooltip>
          </Polyline>
        );
      })}

      {usedAirports.map((a) => {
        if (!a.latitude || !a.longitude) return null;
        const isHub = routes.filter((r) => r.dep === a.iataCode || r.arr === a.iataCode).length >= 3;
        return (
          <CircleMarker
            key={a.iataCode}
            center={[parseFloat(a.latitude), parseFloat(a.longitude)]}
            radius={isHub ? 7 : 4}
            pathOptions={{ color: '#fff', fillColor: '#1976d2', fillOpacity: 1, weight: 1.5 }}
          >
            <MapTooltip permanent={false} direction="top" offset={[0, -6]}>
              <strong>{a.iataCode}</strong> - {a.airportName}
            </MapTooltip>
          </CircleMarker>
        );
      })}
    </MapContainer>
  );
};

export default NetworkMap;
